import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';

export function RESET_POPUP(store, type) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, type);
}
